import { call, put, takeLatest } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* getChatCreatorDetails({ payload: { id, signal, handledErrors } }) {
  try {
    const { data } = yield call(fetch, {
      api: api.creator_object.creator_details_sendbird,
      id,
      signal
    });

    yield put(actions.getChatCreatorDetailsDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getChatCreatorDetailsFailed,
      handledErrors,
      endpoint: api.creator_object.creator_details_sendbird.url
    });
  }
}

export const getChatCreatorDetailsSaga = takeLatest(types.GET_CHAT_CREATOR_DETAILS_REQUEST, getChatCreatorDetails);
